// Auto-generated file - do not edit
export const BUILD_VERSION = '202506100549';
